<div
  class="flex h-full w-full flex-col gap-2 overflow-y-auto overflow-x-hidden p-4"
>
  @for (siaGrid of grids(); track siaGrid) {
    @if (siaGrid.gridId) {
      <div
        class="surface-low flex flex-col rounded-lg p-2 transition-[height] duration-300"
        [style]="{
          height:
            !siaGrid.canLoadData || (siaGrid.compact && siaGrid.allowCompact)
              ? 'fit-content'
              : getGridHeight(siaGrid.minHeight ?? '') + 'px',
        }"
      >
        <div
          class="flex flex-row items-center justify-between"
          [class.mb-2]="siaGrid.canLoadData"
          #header
        >
          <div class="flex flex-row items-center gap-2 text-lg font-semibold">
            {{ siaGrid.title | siaTranslate }}
            @if (siaGrid.additionalTitle) {
              <div class="text-secondary">-</div>
              <div class="text-secondary">{{ siaGrid.additionalTitle }}</div>
            }
          </div>
          <div
            class="flex flex-grow flex-row items-center justify-end gap-4"
            #gridWithActions
          >
            <sia-actions-container
              [pageData]="siaGrid.actionsPageData"
              [buttonsSize]="'medium'"
              [parentWidth]="
                gridWithActions.offsetWidth - collapseButton.offsetWidth - 8
              "
            >
            </sia-actions-container>
            <div #collapseButton>
              @if (siaGrid.allowCompact) {
                <button
                  mat-icon-button
                  [disabled]="!siaGrid.compact || !siaGrid.canLoadData"
                  (click)="expandGrid(siaGrid)"
                >
                  <mat-icon> expand_all </mat-icon>
                </button>
              }
            </div>
          </div>
        </div>

        <div
          [style]="
            'height: calc(100% - ' + header.offsetHeight + 'px - 0.5rem)'
          "
          class="overflow-hidden"
          [class.hidden]="!siaGrid.canLoadData"
        >
          <sia-mat-grid
            [gridId]="siaGrid.gridId"
            [pageData]="siaGrid.pageData"
            [hideArrows]="!siaGrid.allowCompact || siaGrid.hideArrows"
            [showHeaderGrid]="siaGrid.showHeaderGrid"
            [enableGlobalFilterPanel]="false"
            [roundCorners]="true"
            [allowViews]="false"
            [focusClickedRow]="!siaGrid.hideArrows && !!siaGrid.allowCompact"
            [compactInput]="!!siaGrid.compact"
            [allowCompact]="!!siaGrid.allowCompact"
            (rowClicked)="rowClicked($event, siaGrid)"
            [multiGridFiltersInput]="multiGridParameters()"
            [canLoadDataInput]="siaGrid.canLoadData"
            [isMultiGrid]="true"
            [hideHeaderFilters]="!!siaGrid.hideHeaderFilters"
            (selectedGridViewOutput)="selectedGridViewOutput($event, siaGrid)"
          >
          </sia-mat-grid>
        </div>
      </div>
    }
  }
</div>
